// https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Adevai%3Aworkspace
export const buildDevAiWorkspaceAri = (activationId: string): string => {
	return `ari:cloud:devai::workspace/${activationId}`;
};
